module.exports = __webpack_public_path__ + "static/img/bg-es.3a27e57c.webp";